export default __webpack_public_path__ + "static/media/catball.138f2842.png";